import React from 'react'

export default function Footer() {
    return (
        <footer>
            <div className="footer-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 pt-2 mx-auto text-center bg-dark text-light">
                            <h6>Copyright &copy;SumitJoshi 2020</h6>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
